import React from 'react';
import { X, Crown } from "lucide-react";

const MembershipInfoModal = ({ currentPlanId, plansMap, onClose }) => {
    const planMeta = {
        F: { name: "體驗會員", color: "bg-gray-100 text-gray-600 border-gray-200", icon: "👻" },
        A: { name: "基本會員", color: "bg-slate-100 text-slate-600 border-slate-200", icon: "🌱" },
        B: { name: "高級會員", color: "bg-blue-50 text-blue-600 border-blue-200", icon: "🚀" },
        C: { name: "鑽石會員", color: "bg-amber-50 text-amber-600 border-amber-200", icon: "👑" }
    };

    const orderedKeys = ['F', 'A', 'B', 'C'];
    const formatLimit = (val) => {
        if (Number(val) === -1) return "無限暢用";
        if (Number(val) === 0) return "需扣點數";
        return `${val} 次 / 日`;
    };

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in" onClick={onClose}>
            <div className="bg-white rounded-[2rem] w-full max-w-4xl max-h-[85vh] overflow-hidden shadow-2xl relative flex flex-col" onClick={e => e.stopPropagation()}>
                <div className="bg-slate-900 p-6 text-white relative shrink-0">
                     <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all"><X size={18}/></button>
                    <div className="flex items-center gap-3">
                        <Crown size={28} className="text-yellow-400"/>
                        <h3 className="text-xl font-black tracking-wide">會員方案權益一覽</h3>
                    </div>
                    <p className="text-slate-400 text-xs mt-1">了解您的權益，選擇最適合的學習方案</p>
                </div>

                <div className="p-6 overflow-y-auto bg-slate-50 flex-1">
                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {orderedKeys.map(key => {
                            const plan = plansMap[key] || {};
                            const meta = planMeta[key] || planMeta['A'];
                            const isCurrent = currentPlanId === key;
                            return (
                                <div key={key} className={`relative flex flex-col p-5 rounded-2xl border-2 transition-all ${isCurrent ? 'border-orange-400 shadow-lg scale-105 z-10 bg-white' : 'border-slate-100 bg-white hover:border-slate-300'}`}>
                                    {isCurrent && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-[10px] font-bold px-3 py-1 rounded-full shadow-sm">目前方案</div>}
                                    
                                    <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl mb-3 ${meta.color.split(' ')[0]}`}>
                                        {meta.icon}
                                    </div>
                                    <h4 className="text-lg font-black text-slate-800 mb-1">{meta.name}</h4>
                                    <div className="w-10 h-1 bg-slate-100 rounded-full mb-4"></div>

                                    <div className="space-y-3 flex-1">
                                        <div className="flex justify-between items-center text-sm">
                                            <span className="text-slate-500 font-bold">⚡ AI 解析</span>
                                            <span className="font-black text-slate-800">{formatLimit(plan.dailyLimit)}</span>
                                        </div>
                                        <div className="flex justify-between items-center text-sm">
                                            <span className="text-slate-500 font-bold">💡 觀念整理</span>
                                            <span className="font-black text-slate-800">{formatLimit(plan.conceptLimit)}</span>
                                         </div>
                                        <div className="flex justify-between items-center text-sm">
                                            <span className="text-slate-500 font-bold">🔍 舉一反三</span>
                                            <span className="font-black text-slate-800">{formatLimit(plan.similarLimit)}</span>
                                         </div>
                                    </div>
                                    
                                    {!isCurrent && key !== 'F' && (
                                     <div className="mt-6 text-center">
                                            <span className="text-[10px] text-slate-400 bg-slate-100 px-2 py-1 rounded-full">洽詢老師升級</span>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    
                    <div className="mt-8 p-4 bg-orange-50 rounded-xl border border-orange-100 text-center">
                        <p className="text-xs text-orange-700 font-bold leading-relaxed">
                            💡 <span className="underline">額度說明</span>：每日額度於凌晨 00:00 重置。<br/>
                            若當日免費額度用完，您仍可使用 <span className="font-black">帳戶點數</span> 繼續使用所有功能。
                        </p>
                   </div>
                </div>
            </div>
        </div>
    );
};

export default MembershipInfoModal;
